<template>
  <v-card class="card--shadow">
    <v-card-text>
      <v-row>
        <v-col lg="4">
          <label for>Month</label>
          <v-select
            :items="months"
            v-model="data.month"
            item-text="text"
            item-value="value"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col lg="4">
          <label for>Year</label>
          <v-select
            :items="years"
            v-model="data.year"
            item-text="text"
            item-value="value"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col lg="4">
          <label for>DOTS Status</label>
          <v-select
            :items="dotsSupervisionStatus"
            v-model="data.status"
            item-text="text"
            item-value="value"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col lg="4" v-show="data.status == 1">
          <label for>Date</label>
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="data.date"
                outlined
                dense
                readonly
                persistent-hint
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="data.date"
              no-title
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <label for>In Person (days)</label>
          <v-text-field
            v-model="data.in_person"
            type="number"
            dense
          ></v-text-field>
        </v-col>
        <v-col>
          <label for>Phone (days)</label>
          <v-text-field v-model="data.phone" type="number" dense></v-text-field>
        </v-col>
        <v-col>
          <label for>Absent (days)</label>
          <v-text-field
            v-model="data.absent"
            type="number"
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="d-flex justify-end">
        <v-btn class="form-btn" @click="$emit('submit', data)">
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Save
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("InitialData", ["months", "years", "dotsSupervisionStatus"]),
  },
  data() {
    return {
      dateMenu: null,
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          month: "",
          year: "",
          status: "",
          date: "",
          in_person: 0,
          phone: 0,
          absent: 0,
        };
      },
    },
  },
};
</script>

<style></style>
